var Utilities = (function (window, document, IBBC, undefined) {

  'use strict';

  return {

    checkIfIE10: function () {
      /*@cc_on
      if (/^10/.test(@_jscript_version)) {
          IBBC.isIE10 = true;
      }
      @*/

      if (IBBC.isIE10) {
        IBBC.E.classList.add('ie10-browser');
      }
    },
    checkIfIE11: function () {
      IBBC.isIE11 = !(window.ActiveXObject) && 'ActiveXObject' in window;

      if (IBBC.isIE11) {
        IBBC.E.classList.add('ie11-browser');
      }
    },
    checkIfFirefox: function () {
      IBBC.isFirefox = window.navigator.userAgent.search('Firefox');

      if (IBBC.isFirefox != -1) {
        IBBC.E.classList.add('firefox-browser');
      }
    },
    checkIfSafari: function () {
      IBBC.isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);

      if (IBBC.isSafari) {
        IBBC.E.classList.add('safari-browser');
      }
    },
    appendLib: function (lib, async) {
      var async = async || false;
      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = lib;
      if (async) {
        s.setAttribute('async', '');
        s.setAttribute('defer', '');
      }
      NG.D.getElementsByTagName('body')[0].append(s);
    },
    updateWidth: function () {
      return NG.W.innerWidth || NG.E.clientWidth || NG.G.clientWidth;
    }
  };

}(window, document, window.IBBC));



// WEBPACK FOOTER //
// src/assets/js/utilities.js